import React from 'react';
import Header from './Header';
import Footer from './Footer';
import { Toaster } from 'react-hot-toast';
import DealFollowupPopup from './DealFollowupPopup/DealFollowupPopup';

function Layout({ children, showFooter = true, titleVariant = 'logo' }) {
  return (
    <div dir="rtl" className="min-h-screen bg-gradient-to-r from-orange-200 via-peach-300 to-rose-200">
      <div className="max-w-8xl mx-auto px-4 sm:px-6 lg:px-8">
        <Header titleVariant={titleVariant} />
        <main>
          {children}
        </main>
        {showFooter && <Footer />}
        <Toaster />
        <DealFollowupPopup />
      </div>
    </div>
  );
}

export default Layout; 